import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { isNil } from "ramda";

import useStyles from "./useStyles";

const PersonLabel = (props) => {
  const classes = useStyles();
  const { label, relation, onClick, clickable } = props;

  const rootClasses = clsx(classes.root, {
    [classes[`${relation}`]]: !isNil(relation),
    [classes.clickable]: clickable && !isNil(onClick),
  });

  return (
    <button className={rootClasses} type="button" onClick={onClick} disabled={!clickable}>
      <span>{label}</span>
    </button>
  );
};

PersonLabel.propTypes = {
  label: PropTypes.string,
  relation: PropTypes.string,
  onClick: PropTypes.func,
  clickable: PropTypes.bool,
};

PersonLabel.defaultProps = {
  label: "Name",
  relation: null,
  onClick: null,
  clickable: false,
};

export default PersonLabel;
